import GButton from "./";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import IconsPlus from "../icons/plus";

const isNotCompact = (display) => display !== "compact";

<template>
  <GButton
    @type={{@type}}
    @color="outline"
    @disabled={{@disabled}}
    @loading={{@loading}}
    @display={{if @display @display "default"}}
    {{mergeClasses}}
    ...attributes
  >
    <div class="flex items-center">
      <IconsPlus class="w-5 mr-1 {{if (isNotCompact @display) '-ml-1.5'}} -mt-px text-green-100" />
      <span>{{yield}}</span>
    </div>
  </GButton>
</template>
